export const PAGE_USER_DASHBOARD = 'PAGE_USER_DASHBOARD';
export const PAGE_ADMIN_DASHBOARD = 'PAGE_ADMIN_DASHBOARD';
export const PAGE_PERSONAS_ADMIN = 'PAGE_PERSONAS_ADMIN';
export const PAGE_PAGES_ADMIN = 'PAGE_PAGES_ADMIN';
export const PAGE_AUDIT = 'PAGE_AUDIT';
